import { IconName } from "@/shared/components";
import { SuggestieDto } from "@/shared/types";
import { SuggestieStatus } from "../constants";

type SuggestieActieType = SuggestieDto["actie"];

const actieTekstMap = {
    Aanpassen: "updaten",
    Aanvragen: "bestellen",
    Communiceren: "bericht versturen",
    Stoppen: "stoppen",
} satisfies Record<SuggestieActieType, string>;

// Extend any new Suggesties from this BaseSuggestie type
export type BaseSuggestie = {
    id: number;
    objectId: number | undefined;
    type: SuggestieDto["type"];
    variant: "Action" | "Message";
    titel: string;
    omschrijving: string;
    knopTekst: string;
    knopIcon: IconName;
    navigeerNaar: string;
    verstuurdOpDatumTijd: Date;
    status: SuggestieStatus;
};

export type KoffieTheeSuggestie = BaseSuggestie & {
    type: "KoffieThee";
    variant: "Action";
};

export const KoffieTheeSuggestie = {
    fromDto: (dto: SuggestieDto): KoffieTheeSuggestie => ({
        id: dto.id,
        objectId: dto.objectId,
        verstuurdOpDatumTijd: new Date(dto.verstuurdOpDatumTijd),
        status: dto.status,
        type: "KoffieThee",
        variant: "Action",
        titel: `Koffie/Thee ${actieTekstMap[dto.actie]}`,
        omschrijving: dto.omschrijving,
        knopTekst: "Naar faciliteiten",
        knopIcon: "coffee",
        navigeerNaar: "faciliteiten",
    }),
};

export type BusdienstSuggestie = BaseSuggestie & {
    type: "Busdienst";
    variant: "Action";
};

export const BusdienstSuggestie = {
    fromDto: (dto: SuggestieDto): BusdienstSuggestie => ({
        id: dto.id,
        objectId: dto.objectId,
        verstuurdOpDatumTijd: new Date(dto.verstuurdOpDatumTijd),
        status: dto.status,
        type: "Busdienst",
        variant: "Action",
        titel: "ETAs busdienst tonen",
        omschrijving: dto.omschrijving,
        knopTekst: "Naar busdienst",
        knopIcon: "bus",
        navigeerNaar: dto.objectId ? `tvv?routeId=${dto.objectId}` : "tvv",
    }),
};

export type VossenSuggestie = BaseSuggestie & {
    type: "Vossen";
    variant: "Action";
};

export const VossenSuggestie = {
    fromDto: (dto: SuggestieDto): VossenSuggestie => ({
        id: dto.id,
        objectId: dto.objectId,
        verstuurdOpDatumTijd: new Date(dto.verstuurdOpDatumTijd),
        status: dto.status,
        type: "Vossen",
        variant: "Action",
        titel: `VOS'en ${actieTekstMap[dto.actie]}`,
        omschrijving: dto.omschrijving,
        knopTekst: "Naar VOS aanvraag",
        knopIcon: "users",
        navigeerNaar: "medewerkers-op-station",
    }),
};

export type HerinneringSuggestie = BaseSuggestie & {
    type: "Herinnering";
    variant: "Message";
};

export const HerinneringSuggestie = {
    fromDto: (dto: SuggestieDto): HerinneringSuggestie => ({
        id: dto.id,
        objectId: dto.objectId,
        verstuurdOpDatumTijd: new Date(dto.verstuurdOpDatumTijd),
        status: dto.status,
        type: "Herinnering",
        variant: "Message",
        titel: dto.omschrijving,
        omschrijving: "Toegevoegde herinnering",
        knopTekst: "Naar herinnering",
        knopIcon: "alarm",
        navigeerNaar: "",
    }),
};

export type Suggestie = KoffieTheeSuggestie | BusdienstSuggestie | VossenSuggestie | HerinneringSuggestie;

export const Suggestie = {
    fromDto: (dto: SuggestieDto): Suggestie => {
        switch (dto.type) {
            case "KoffieThee":
                return KoffieTheeSuggestie.fromDto(dto);
            case "Busdienst":
                return BusdienstSuggestie.fromDto(dto);
            case "Vossen":
                return VossenSuggestie.fromDto(dto);
            case "Herinnering":
                return HerinneringSuggestie.fromDto(dto);
        }
    },
};
